import Repository from './Repository';

class WebhookRepository extends Repository {}

export default new WebhookRepository({ baseUrl: '/webhook' });
